import { get } from '@intigral/utils/lib/browser-storage/localStorage';
import { STORE_NAME } from '@intigral/constant';
import { IUserFullObject } from '@intigral/types';
import { IChannels } from '../types/iEpgGudeContainer';

export const isChannelLocked = (channel: IChannels): boolean => {
    // const isLockedChannel = () => {
    // For PPV channels, use the proper PPV logic
    if (channel?.isPPV) {
        const userInfo = get(STORE_NAME.USER) as IUserFullObject;
        const userPpvList = userInfo?.ppvList || [];
        const channelSubscriptionGuids = channel?.subscriptions?.map((sub) => sub.subscriptionGUID) || [];

        const isSubscribedToPPV = channelSubscriptionGuids.some((guid: string) =>
            userPpvList.some((ppvEvent) => {
                const matchBySubscriptionGuid = ppvEvent.subscriptionGuid === guid;
                const matchByGuid = ppvEvent.guid === guid;
                const matchByEventId = ppvEvent.eventId === guid;
                return matchBySubscriptionGuid || matchByGuid || matchByEventId;
            })
        );

        // For PPV channels: show lock if user is NOT subscribed
        return !isSubscribedToPPV;
    }

    // For non-PPV channels, use original logic
    return Boolean(channel?.locked || channel?.isLockedEpg);
};

// TODO: instead of passing container ref through context maybe scrollLeft() can be used to scroll the element
// itself
// const epgContainerRef = useContext(EpgContainerRefContext);
// useEffect(() => {
//     if (selectedChannel === channel.uuid && epgContainerRef?.current) {
//         // elementRef.current.scrollIntoView({ behavior: 'smooth' });
//         epgContainerRef.current.scrollTo({ top: position.top, behavior: 'smooth' });
//     }
// }, [selectedChannel, epgContainerRef, channel, position.top]);

// return {
//     isLockedChannel,
// };
// };
